import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextGamesSharedModule } from '@games/games-shared/text-games-shared.module';
import { SharedModule } from '@games/speed-reading/shared/shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { FitTextModule, FormFieldModule, TextsFilterComponent } from '@shared/components/games';
import { FontParametersModule } from '@shared/components/games/font-parameters';
import { SpurtzControllerComponent } from './spurtz-controller/spurtz-controller.component';
import { SpurtzCorrectAnswerPreviewComponent } from './spurtz-preview/spurtz-answer-preview/spurtz-answer-preview.component';
import { SpurtzExamplePreviewComponent } from './spurtz-preview/spurtz-example-preview/spurtz-example-preview.component';
import { SpurtzParametersPreviewComponent } from './spurtz-preview/spurtz-parameters-preview/spurtz-parameters-preview.component';
import { SpurtzUserAnswerPreviewComponent } from './spurtz-preview/spurtz-user-answer-preview/spurtz-user-answer-preview.component';
import { SpurtzSettingsComponent } from './spurtz-settings/spurtz-settings.component';
import { MatTooltip } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    SpurtzControllerComponent,
    SpurtzSettingsComponent,
    SpurtzCorrectAnswerPreviewComponent,
    SpurtzExamplePreviewComponent,
    SpurtzParametersPreviewComponent,
    SpurtzUserAnswerPreviewComponent,
  ],
  exports: [
    SpurtzControllerComponent,
    SpurtzSettingsComponent,
    SpurtzCorrectAnswerPreviewComponent,
    SpurtzExamplePreviewComponent,
    SpurtzParametersPreviewComponent,
    SpurtzUserAnswerPreviewComponent,
    NgSelectModule,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    FitTextModule,
    NgSelectModule,
    TextsFilterComponent,
    SharedModule,
    TextGamesSharedModule,
    FontParametersModule,
    FormFieldModule,
    MatTooltip,
  ],
})
export class SpurtzModule {}
